module.exports = "<fm-menu></fm-menu>\r\n"